import { Link } from 'react-router-dom';

const navItems = [
  { label: 'BACK', href: '/' },
  { label: 'HOME', href: '#hero' },
  { label: 'ABOUT', href: '#about' },
  { label: 'WINNERS', href: '#winners-glance' },
  { label: 'DOCUMENTATION', href: '#documentation', wrap: true },
  { label: 'CONTACTS', href: '#contacts' },
];

export default function LeftSidebar({ visible, showNav, logo }) {
  const handleClick = (e, href) => {
    if (href.startsWith('#')) {
      e.preventDefault();
      const el = document.querySelector(href);
      if (el) el.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <aside
      className={`fixed left-0 top-0 bottom-0 z-40 flex flex-col items-center w-[150px] xl:w-[180px] ${visible ? 'opacity-100' : 'opacity-0 pointer-events-none'}`}
      style={{
        background: 'linear-gradient(180deg, rgba(110,160,220,0.28) 0%, rgba(150,190,235,0.3) 50%, rgba(120,170,225,0.26) 100%)',
        backdropFilter: 'blur(12px)',
        WebkitBackdropFilter: 'blur(12px)',
        border: '1px solid rgba(190,220,255,0.3)',
        borderLeft: 'none',
        borderRadius: '0 14px 14px 0',
        boxShadow: '0 0 24px rgba(120,180,255,0.12), inset 0 0 30px rgba(180,215,255,0.08)',
        overflow: 'visible',
        willChange: 'opacity',
        transition: 'opacity 0.4s ease',
      }}
    >
      <div
        className="absolute inset-0 pointer-events-none"
        style={{
          borderRadius: 'inherit',
          background: `repeating-linear-gradient(0deg, transparent, transparent 18px, rgba(100,180,255,0.04) 18px, rgba(100,180,255,0.04) 19px), repeating-linear-gradient(90deg, transparent, transparent 18px, rgba(100,180,255,0.03) 18px, rgba(100,180,255,0.03) 19px)`,
        }}
      />

      <div
        className="flex items-center justify-center"
        style={{
          position: 'absolute',
          left: '-20px',
          top: '50%',
          transform: 'translateY(-50%)',
          width: '22px',
          height: '44px',
          borderRadius: '6px 0 0 6px',
          background: 'linear-gradient(180deg, rgba(180,210,255,0.35) 0%, rgba(100,160,230,0.25) 100%)',
          border: '1px solid rgba(180,215,255,0.3)',
          borderRight: 'none',
          boxShadow: '-2px 0 12px rgba(80,160,255,0.15), inset 0 1px 0 rgba(255,255,255,0.2)',
          cursor: 'default',
        }}
      >
        <span style={{ color: 'rgba(220,235,255,0.8)', fontSize: '0.55rem', textShadow: '0 0 6px rgba(150,200,255,0.4)', lineHeight: 1 }}>◀</span>
      </div>

      <nav
        className="flex flex-col items-center gap-4 pt-12 pb-4 px-3 flex-1 justify-start relative"
        style={{
          zIndex: 1,
          opacity: showNav ? 1 : 0,
          transform: showNav ? 'translateY(0)' : 'translateY(8px)',
          transition: 'opacity 0.4s ease, transform 0.4s ease',
          pointerEvents: showNav ? 'auto' : 'none',
        }}
      >
        {navItems.map((item) =>
          item.href.startsWith('/') ? (
            <Link key={item.label} to={item.href} className="spss-nav-btn" title={item.label} tabIndex={showNav ? 0 : -1}>
              <span>{item.label}</span>
            </Link>
          ) : (
            <a key={item.label} href={item.href} className="spss-nav-btn" title={item.label} onClick={(e) => handleClick(e, item.href)} tabIndex={showNav ? 0 : -1}>
              <span>{item.label}</span>
            </a>
          )
        )}
      </nav>

      {logo && (
        <div className="flex flex-col items-center pb-6 pt-4 relative" style={{ zIndex: 1 }}>
          <img
            src={logo}
            alt="SPSS Logo"
            style={{ width: '124px', height: 'auto', filter: 'drop-shadow(0 0 10px rgba(100,180,255,0.35)) drop-shadow(0 0 20px rgba(80,160,255,0.15))', opacity: 0.9 }}
          />
        </div>
      )}
    </aside>
  );
}